export default __webpack_public_path__ + "static/media/Icon simple-instagram.37d6d662.svg";